import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-749467ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "categories-box" }
const _hoisted_2 = ["onContextmenu", "onClick", "onMousedown", "onMouseenter", "onMouseleave"]
const _hoisted_3 = { class: "item-cont" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "detail" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = {
  key: 0,
  class: "name"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comp-mark-mask" }, null, -1))
const _hoisted_10 = ["onMousedown"]
const _hoisted_11 = {
  key: 2,
  class: "name"
}
const _hoisted_12 = {
  key: 3,
  class: /*#__PURE__*/_normalizeClass({ add: true })
}
const _hoisted_13 = {
  key: 2,
  class: "comp-mark"
}
const _hoisted_14 = { class: "item-cont" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "detail" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "desc" }

import SearchComponent from '@/components/SearchComponent.vue';
import { Plus } from '@rafter/icon';
import { onMounted, reactive, ref, watch } from 'vue';
import ClockBar from '@/components/ClockBar.vue';
import FolderItem from '@/components/FolderItem.vue';
import draggable from 'vuedraggable';
import AddComp from '@/components/AddComp.vue';
import { databaseDb } from '@/lib/Database';
import {
  delBookmark,
  putBookmark,
  getBookmarks,
  syncToServer,
} from '@/api/baseApi';
import { RaMessage, RaImage } from '@rafter/pc';
import { activeCatetory, bookmarks } from '@/store/bookmarks';
import ModelBtn from '@/components/ModelBtn';
import { settings } from '@/store/settings';
import LittleComponent from '@/external-components/index.vue';
import SubscriptionModal from '@/components/SubscriptionModal.vue';
import { plugins } from '@/store/plugins';
import { user } from '@/store/user';

export default /*#__PURE__*/_defineComponent({
  __name: 'ComplexMode',
  props: {
  categorie: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['showLogin'],
  setup(__props, { emit: emits }) {

const props = __props;

const logoUrl = ref('./assets/logo.png');
const group = {
  name: 'group',
  pull: true,
  put: true,
};
const position = reactive({ top: '0px', left: '0px' });
const detail = ref(null);
const isUp = ref(false);
const scrollTimes = ref(0);
const isScroll = ref(false);
const dragItem = ref({});
const borderStyle = ref('');
const list = ref([]);
const showGroup = ref(false);
const showActionMenu = ref(false);
const showAdd = ref(false);
const actionMenu = ref(null);
const groupList = ref([]);
const listRef = ref();
const groupRef = ref();
const showLittleComponent = ref(false);
const subscriptionModalShow = ref(false);

/**
 * @description: 更新书签
 */
const changeActiveMarks = (value) => {
  list.value = [];
  value.forEach((item) => {
    const group_list = value.filter(
      (i) => item.group_uuid && i.group_uuid === item.group_uuid
    );
    // if (item.type === 2) {
    //   const groupItem = { ...item };
    //   let children = [];
    //   const filterArr = value.filter((i) => i.group_uuid === item.uuid);
    //   children = [...filterArr];
    //   groupItem.children = children;
    //   if (!filterArr.length) {
    //     delBookmark(item.uuid);
    //     return;
    //   }
    //   if (filterArr.length === 1) {
    //     filterArr.forEach((child) => {
    //       putBookmark(child.uuid, {
    //         ...child,
    //         group_uuid: '',
    //       });
    //     });
    //     delBookmark(item.uuid);
    //     return;
    //   }
    //   list.value.push(groupItem);
    //   return;
    // }

    if ((!item.group_uuid && item.type !== 2) || group_list?.length === 1) {
      const plugin = plugins.objList[item.url];
      if (item.type === 3 && plugin) {
        item.name = plugin.name;
        item.logo = plugin.logo;
        item.describe = plugin.describe;
        item.attribute = plugin.attribute;
      }
      list.value.push(item);
    }
  });
  list.value.push({
    name: '新增',
    id: 'add',
  });
  if (!bookmarks.oldActive) return;
  if (bookmarks.getActive()?.order > bookmarks.oldActive?.order) {
    isUp.value = true;
  } else {
    isUp.value = false;
  }
};
watch(
  activeCatetory,
  (value) => {
    changeActiveMarks(value);
  },
  { deep: true }
);

watch(
  () => [databaseDb.value],
  () => {
    getMarks();
  }
);
const getMarks = () => {};


/**
 * @name:
 * @description: 新增小组件
 * @msg:
 * @return {*}
 */
const handleAddComp = (e, element) => {
  e.stopPropagation();
  e.preventDefault();
  // Todo
  // if (element.type === 2) {
  //   groupItem = element;
  //   if (element.children?.length) {
  //     groupList.value = element.children;
  //   }
  //   showGroup.value = true;
  //   return;
  // }
  if (element.id === 'add') {
    showAdd.value = true;
    detail.value = null;
  } else {
    if (element.type !== 3) {
      if (!mousemove.value) {
        bookmarks.gotoMark(element);
      }
    } else {
      if (!mousemove.value) {
        const target = plugins.list.find((item) => {
          return item.url === element.url;
        });
        if (target && target.authority > 1 && !user.token) {
          emits('showLogin');
          return;
        }

        detail.value = element;
        showLittleComponent.value = true;
      }
    }
  }
};
const handleEdit = () => {
  showAdd.value = true;
  showActionMenu.value = false;
};
const handleDelete = () => {
  delBookmark(detail.value.uuid).then((res) => {
    RaMessage({
      message: '删除成功',
      type: 'success',
    });
    showActionMenu.value = false;

    bookmarks.removeOneInActive(detail.value.uuid);
  });
  if (detail.value.type === 2) {
    detail.value.children.forEach((item) => {
      delBookmark(item.uuid).then((res) => {
        bookmarks.removeOneInActive(detail.value.uuid);
      });
    });
  }
};

const handleActionMenu = (e, element) => {
  if (element.id !== 'add') {
    e.preventDefault();
    detail.value = element;
    position.left = `${e.clientX}px`;
    position.top = `${e.clientY}px`;
    showActionMenu.value = true;
    detail.value = element;
  }
};

const testBlur = () => {
  showActionMenu.value = false;
};
const handleChangeMode = () => {
  settings.isSimple = true;
};
onMounted(() => {
  changeActiveMarks(activeCatetory.value);
});
const styleProps = ref({});
const isDragging = ref(false);
const mousemove = ref(false);
let offsetX, offsetY;
let parentLeft, parentTop;
let left, top, right, bottom;
let selectItem;
const handleMouseDown = (e, item) => {
  if (item.id === 'add' || e.button !== 0) return;
  e.stopPropagation();
  e.preventDefault();
  isDragging.value = true;
  mousemove.value = false;
  left = e.target.getBoundingClientRect().left;
  top = e.target.getBoundingClientRect().top;
  right = e.target.getBoundingClientRect().right;
  bottom = e.target.getBoundingClientRect().bottom;
  parentLeft =
    e.target.parentElement.parentElement.getBoundingClientRect().left;
  parentTop = e.target.parentElement.parentElement.getBoundingClientRect().top;
  offsetX = e.offsetX;
  offsetY = e.offsetY;
  dragItem.value = item;
  selectItem = item;
  styleProps.value = {
    left: e.clientX - offsetX + 'px',
    top: e.clientY - offsetY + 'px',
    zIndex: 5,
    display: 'unset',
  };
};
let groupItem;
const handleMouseUp = async (e) => {
  if (isDragging.value) {
    isDragging.value = false;
    activeItem.value = {};
    if (!showGroup.value) {
      styleProps.value = {
        left: left + 'px',
        top: top + 'px',
        display: 'unset',
      };
      setTimeout(() => {
        styleProps.value = {
          display: 'none',
        };
      });
      const normalList = JSON.parse(JSON.stringify(list.value)) || [];
      for (let i in normalList) {
        if (normalList[i].uuid) {
          await putBookmark(
            normalList[i].uuid,
            {
              ...normalList[i],
              ...(newCategory.value.uuid && {
                category_uuid: newCategory.value.uuid,
              }),
              order: i,
              group_uuid: '',
            },
            false
          );
        }
      }
      if (mousemove.value) {
        syncToServer();
      }

      // normalList
      //   .filter((item) => item.uuid)
      //   .forEach((item, index) => {
      //     putBookmark(item.uuid, {
      //       ...item,
      //       ...(newCategory.value.uuid && {
      //         category_uuid: newCategory.value.uuid,
      //       }),
      //       order: index,
      //       group_uuid: '',
      //     });
      //   });
      const category = {
        ...bookmarks.getActive(),
        bookmarks: normalList.filter((item) => item.uuid),
      };
      bookmarks.updateCategory(category);
      if (oldCategory.value.uuid) {
        const marksList = (oldCategory.value.bookmarks || []).filter(
          (item) => item.uuid !== dragItem.value.uuid
        );
        bookmarks.updateCategory({
          ...oldCategory.value,
          bookmarks: marksList,
        });
      }
      // 清空拖拽切换分类标记
      newCategory.value = {};
      oldCategory.value = {};
    } else {
      styleProps.value = {
        display: 'none',
      };
      const normalList = JSON.parse(JSON.stringify(groupList.value)) || [];

      for (let i in normalList) {
        const item = normalList[i];
        await putBookmark(item.uuid, { ...item, order: i }, false);
      }
      syncToServer();
      // normalList.forEach((item, index) => {
      //   putBookmark(item.uuid, { ...item, order: index }, false);
      // });
      list.value = list.value.map((item) => {
        if (item.uuid === groupItem.uuid) {
          return { ...item, children: normalList };
        }
        return item;
      });
    }
  }
};
let groupTimer;
const activeItem = ref({});
const handleItemEnter = (e, item) => {
  // tode
  return;
  if (
    isDragging.value &&
    dragItem.value.uuid !== item.uuid &&
    item.id !== 'add' &&
    dragItem.value.type === 1
  ) {
    groupTimer = setTimeout(() => {
      if (!showGroup.value) {
        showGroup.value = true;

        if (item.children?.length) {
          groupItem = {
            ...item,
            type: 2,
            children: [...item.children, dragItem.value],
          };
          const childrenList = groupItem.children.map((child, index) => {
            putBookmark(child.uuid, {
              ...child,
              group_uuid: item.uuid,
              order: index,
            });
            return { ...child, group_uuid: item.uuid, order: index };
          });
          groupItem = {
            ...groupItem,
            children: childrenList,
          };
          activeItem.value = groupItem;
          list.value = list.value.map((li) => {
            if (li.uuid === item.uuid) {
              return groupItem;
            }
            return li;
          });
          list.value = list.value.filter(
            (item) => item.uuid !== dragItem.value.uuid
          );

          groupList.value = [...childrenList];
        } else {
          groupItem = {
            ...item,
            uuid: Date.now(),
            type: 2,
            children: [item, dragItem.value],
          };
          activeItem.value = groupItem;
          addBookmark({
            type: 2,
            name: '文件夹',
            category_uuid: bookmarks.getActive()?.uuid,
            order: item.order,
          }).then((res) => {
            const childrenList = groupItem.children.map((child, index) => {
              putBookmark(child.uuid, {
                ...child,
                group_uuid: res.uuid,
                order: index,
              }).then((res) => {});
              return { ...child, group_uuid: res.uuid, order: index };
            });
            groupItem = {
              ...res,
              children: childrenList,
            };
            activeItem.value = groupItem;
            list.value = list.value.map((li) => {
              if (li.uuid === item.uuid) {
                return groupItem;
              }
              return li;
            });
            list.value = list.value.filter(
              (item) => item.uuid !== dragItem.value.uuid
            );
            groupList.value = [...childrenList];
          });
        }
      }
    }, 700);
  }
};
const newCategory = ref({});
const oldCategory = ref({});
let closeGroupTimer;
const handleMouseMove = (e) => {
  clearTimeout(timer);

  if (isDragging.value && groupRef.value?.getMouseState() === false) {
    timer = setTimeout(() => {
      handleCloseModal();
    }, 1000);
  }
  let listElements;
  if (showGroup.value) {
    listElements = groupRef.value?.getElements();
  } else {
    listElements = document.querySelectorAll('.book-mark');
  }
  if (isDragging.value) {
    const positionList = [];
    listElements.forEach((element, index) => {
      const rect = element.getBoundingClientRect();

      positionList.push({
        left: rect.left,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
      });
    });
    let arr;
    if (showGroup.value) {
      arr = groupList.value.map((item, index) => ({
        ...item,
        position: positionList[index],
      }));
    } else {
      arr = list.value.map((item, index) => ({
        ...item,
        position: positionList[index],
      }));
    }
    const insterItem = arr.find(
      (item) =>
        item.position.right > e.clientX &&
        item.position.top < e.clientY &&
        item.position.bottom > e.clientY
    );
    if (insterItem && insterItem.uuid !== dragItem.value.uuid) {
      mousemove.value = true;
      let index;
      if (showGroup.value) {
        index = groupList.value
          .filter((item) => item.uuid !== dragItem.value.uuid)
          .findIndex((item) => item.uuid === insterItem.uuid);
      } else {
        index = list.value
          .filter((item) => item.uuid !== dragItem.value.uuid)
          .findIndex((item) => item.uuid === insterItem.uuid);
      }
      let isLess;
      if (showGroup.value) {
        isLess =
          index <
          groupList.value.findIndex((item) => insterItem.uuid === item.uuid);
      } else {
        isLess =
          index < list.value.findIndex((item) => insterItem.uuid === item.uuid);
      }
      let newArr;
      if (showGroup.value) {
        newArr = groupList.value.filter(
          (item) => item.uuid !== dragItem.value.uuid
        );
        newArr.splice(index, 0, dragItem.value);
      } else {
        newArr = list.value.filter((item) => item.uuid !== dragItem.value.uuid);
        newArr.splice(index, 0, dragItem.value);
      }

      if (isLess) {
        if (showGroup.value) {
          groupList.value = newArr;
        } else {
          list.value = newArr;
        }
      } else {
        if (e.clientX < insterItem.position.left) {
          if (showGroup.value) {
            groupList.value = newArr;
          } else {
            list.value = newArr;
          }
        }
      }
    }
    styleProps.value = {
      left: e.clientX - offsetX + 'px',
      top: e.clientY - offsetY + 'px',
      zIndex: 4,
      display: 'unset',
    };
    dragItem.value = selectItem || {};
  }
  // 拖拽更换分类
  if (e.target.className?.includes?.('side-icon')) {
    const className = e.target.className;
    const nextCategory = bookmarks.categories.find((item) =>
      className.includes(item.uuid)
    );
    if (isDragging.value && nextCategory.uuid !== bookmarks.getActive().uuid) {
      newCategory.value = nextCategory;
      oldCategory.value = bookmarks.getActive();
      bookmarks.setActive(nextCategory);
    }
  }
};
let timer;
let setItemTimer;
const handleWheel = (event) => {
  scrollTimes.value += 1;
  clearTimeout(timer);
  timer = setTimeout(() => {
    scrollTimes.value = 0;
  }, 100);
  if (scrollTimes.value > 1 && !isScroll.value) {
    clearTimeout(setItemTimer);
    setItemTimer = setTimeout(() => {
      if (bookmarks.categories?.length) {
        if (event.deltaY > 0) {
          const nextIndex =
            bookmarks.categories.findIndex((item) => item.active) ===
            bookmarks.categories.length - 1
              ? 0
              : bookmarks.categories.findIndex((item) => item.active) + 1;
          if (nextIndex === 0) return;
          const nextItem = bookmarks.categories[nextIndex];
          bookmarks.setActive(nextItem);
          isUp.value = true;
        } else {
          const nextIndex =
            bookmarks.categories.findIndex((item) => item.active) === 0
              ? bookmarks.categories.length - 1
              : bookmarks.categories.findIndex((item) => item.active) - 1;
          if (nextIndex === bookmarks.categories.length - 1) return;
          const nextItem = bookmarks.categories[nextIndex];
          bookmarks.setActive(nextItem);
          isUp.value = false;
        }
      }
    }, 200);
  }
};
const handleItemLeave = (e, item) => {
  clearTimeout(groupTimer);
};
let openTimer;
const handleCloseModal = () => {
  if (showGroup.value) {
    showGroup.value = false;
    // refresh();
    if (isDragging.value) {
      list.value.splice(list.value.length - 1, 0, dragItem.value);

      groupList.value = groupList.value.filter(
        (item) => item.uuid !== dragItem.value.uuid
      );
      list.value = list.value.map((item) => {
        if (item.uuid === groupItem.uuid) {
          return { ...item, children: groupList.value };
        }
        return item;
      });
      list.value = list.value.map((item) => {
        if (item.children?.length === 1) {
          delBookmark(item.uuid);
          return { ...item.children[0], group_uuid: '' };
        }
        return item;
      });
    }
  }
};
const handleScoll = (e: any) => {
  if (
    e.target.offsetHeight - 5 + e.target.scrollTop ===
      listRef.value.$el.scrollHeight ||
    e.target.scrollTop === 0
  ) {
    isScroll.value = false;
  } else {
    isScroll.value = true;
  }
};

const openNewTab = (e, url: string) => {
  e.stopPropagation();
  e.preventDefault();

  window.open(url);
};

return (_ctx: any,_cache: any) => {
  const _directive_clickoutside = _resolveDirective("clickoutside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "page",
      onMousemove: _cache[1] || (_cache[1] = ($event: any) => (handleMouseMove($event))),
      onMouseup: _cache[2] || (_cache[2] = ($event: any) => (handleMouseUp($event)))
    }, [
      _createVNode(_unref(ModelBtn), { onHandleChange: handleChangeMode }),
      _createVNode(SearchComponent, { class: "search-bar" }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["types", { isUp: isUp.value }]),
          onScroll: handleScoll,
          onWheel: handleWheel
        }, [
          _createVNode(_TransitionGroup, {
            name: "list",
            tag: "div",
            class: _normalizeClass({ 'bookmarks-box': true }),
            ref_key: "listRef",
            ref: listRef
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (element, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: element.uuid || index,
                  class: _normalizeClass({
              'book-mark': true,
              unmover: element.id === 'add',
              draggable: element.id !== 'add',
              'comp-mark': element.type === 3,
              border: borderStyle.value === element.uuid,
              'clock-bar': element.size === 0,
              'folder-item': element.size === 2,
            }),
                  onContextmenu: ($event: any) => (handleActionMenu($event, element)),
                  onClick: ($event: any) => (handleAddComp($event, element)),
                  onMousedown: ($event: any) => (handleMouseDown($event, element)),
                  onMouseenter: ($event: any) => (handleItemEnter($event, element)),
                  onMouseleave: ($event: any) => (handleItemLeave($event, element)),
                  style: _normalizeStyle({
              opacity:
                dragItem.value.uuid === element.uuid && element.uuid && isDragging.value
                  ? 0
                  : 1,
              zIndex: 1,
            })
                }, [
                  (element.type !== 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (element.id !== 'add' && element.icon)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass({
                  'icon-image': true,
                  border:
                    activeItem.value.uuid === element.uuid && element.id !== 'add',
                }),
                              style: _normalizeStyle({
                  background: `url(${element.icon})`,
                  width: '80px',
                  height: '80px',
                }),
                              alt: ""
                            }, null, 6))
                          : _createCommentVNode("", true),
                        (element.id !== 'add' && !element.icon)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass({
                  'icon-name': true,
                  border:
                    activeItem.value.uuid === element.uuid && element.id !== 'add',
                }),
                              style: _normalizeStyle({ backgroundColor: element.color })
                            }, _toDisplayString(element.name), 7))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (element.type === 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", {
                            class: "icon",
                            style: _normalizeStyle({ backgroundColor: element.color })
                          }, [
                            _createElementVNode("img", {
                              src: element.icon,
                              alt: ""
                            }, null, 8, _hoisted_4)
                          ], 4),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(element.name), 1),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(element.describe || element.name), 1)
                          ])
                        ]),
                        (
                  _unref(settings).bookmarksConfig.includes('showName') &&
                  element.id !== 'add'
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(element.name), 1))
                          : _createCommentVNode("", true),
                        _hoisted_9,
                        (element?.attribute?.isBlank)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 1,
                              class: "newtab-btn iconfont icon-onetabdakaixinchuangkou",
                              onMousedown: ($event: any) => (openNewTab($event, element.url))
                            }, null, 40, _hoisted_10))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (
                _unref(settings).bookmarksConfig.includes('showName') &&
                element.id !== 'add'
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(element.name), 1))
                    : _createCommentVNode("", true),
                  (
                element.id === 'add' &&
                _unref(settings).bookmarksConfig.includes('showIcon') &&
                !_unref(bookmarks).getActive()?.share_origin_uuid
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_unref(Plus), { class: "plus" })
                      ]))
                    : _createCommentVNode("", true)
                ], 46, _hoisted_2))
              }), 128))
            ]),
            _: 1
          }, 512)
        ], 34)
      ]),
      _createElementVNode("div", {
        style: _normalizeStyle({
        position: 'fixed',
        pointerEvents: 'none',
        display: 'none',
        ...styleProps.value,
      }),
        class: "book-mark"
      }, [
        (dragItem.value.type === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (dragItem.value.icon)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({
            'icon-image': true,
          }),
                    style: _normalizeStyle({
            background: `url(${dragItem.value.icon})`,
            width: '80px',
            height: '80px',
          }),
                    alt: ""
                  }, null, 4))
                : _createCommentVNode("", true),
              (!dragItem.value.icon)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass({
            'icon-name': true,
          }),
                    style: _normalizeStyle({ backgroundColor: dragItem.value.color })
                  }, _toDisplayString(dragItem.value.name), 5))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (dragItem.value.type === 2)
          ? (_openBlock(), _createBlock(FolderItem, {
              key: 1,
              list: dragItem.value.children
            }, null, 8, ["list"]))
          : _createCommentVNode("", true),
        (dragItem.value.type === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  class: "icon",
                  style: _normalizeStyle({ backgroundColor: dragItem.value.color })
                }, [
                  _createElementVNode("img", {
                    src: dragItem.value.icon,
                    alt: ""
                  }, null, 8, _hoisted_15)
                ], 4),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(dragItem.value.name), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(dragItem.value.describe || dragItem.value.name), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 4),
      (showAdd.value)
        ? (_openBlock(), _createBlock(AddComp, {
            key: 0,
            class: "add-comp",
            onHandleClose: _cache[0] || (_cache[0] = ($event: any) => (showAdd.value = false)),
            categorie: props.categorie,
            onGetMarks: getMarks,
            detail: detail.value
          }, null, 8, ["categorie", "detail"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      (showActionMenu.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "action-menu",
            style: _normalizeStyle(position),
            ref_key: "actionMenu",
            ref: actionMenu
          }, [
            (detail.value?.type !== 3)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "text",
                  onClick: handleEdit
                }, " 编辑书签 "))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "text",
              onClick: handleDelete
            }, "删除")
          ], 4)), [
            [_directive_clickoutside, testBlur]
          ])
        : _createCommentVNode("", true)
    ], 32),
    (showLittleComponent.value)
      ? (_openBlock(), _createBlock(LittleComponent, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showLittleComponent.value = false)),
          detail: detail.value
        }, null, 8, ["detail"]))
      : _createCommentVNode("", true),
    (subscriptionModalShow.value)
      ? (_openBlock(), _createBlock(SubscriptionModal, {
          key: 1,
          onHandleClose: _cache[4] || (_cache[4] = ($event: any) => (subscriptionModalShow.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})